import makeCrud from '@/store/site/localization/crud'
const module = makeCrud('manager_customer')
module.actions.impersonate = async function (_, { id }) {
    const res = await this._vm.axios.post(this._vm.endpoint.get('manager_customer') + '/' + id + '/impersonate')
    return res.data
}
export default module
